import React from 'react';

import { Checkbox, Col, Row } from '@bringg/react-components';
import { observer } from 'mobx-react';
import { ComponentWithForm } from '@bringg/react-pages/dist/components';
import { Controller } from 'react-hook-form';

import useStores from '../../../../recipes/use-stores';
import { FleetTemplateSelection } from '../../../../stores/fleets/fleets-store';

const AvailableFleetsOptions = observer(({ form, defaultValues }: ComponentWithForm<FleetTemplateSelection>) => {
	const { fleetsStore } = useStores();
	const { control } = form;

	return (
		<Row>
			{fleetsStore.getFleetTemplateIds.map(fleetId => (
				<Col span={6} key={`${fleetId}`}>
					<Controller
						render={({ value, onChange }) => (
							<Checkbox
								checked={value}
								onChange={e => onChange(e.target.checked)}
								className="fleet-checkbox"
							>
								{fleetsStore.getFleetTemplateById(fleetId).name}
							</Checkbox>
						)}
						name={fleetId.toString()}
						control={control}
						defaultValue={defaultValues[fleetId]}
					/>
				</Col>
			))}
		</Row>
	);
});

export default AvailableFleetsOptions;
